import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../../common/AppShell';
import { useAuth } from '../../common/AuthGate';

const More = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const items = [
    { path: '/contacts', icon: 'call', title: 'Контакты', description: 'Адрес, телефон, режим работы' },
    { path: '/delivery', icon: 'local_shipping', title: 'Доставка', description: 'Тарифы, часы, условия' },
    { path: '/available', icon: 'health_and_safety', title: 'Доступность сайта', description: 'Статус сайта и заглушка' },
  ];

  return (
    <section className="screen-stack">
      <div className="list-card">
        {items.map((item) => (
          <button type="button" className="nav-row" key={item.path} onClick={() => navigate(item.path)}>
            <span className="nav-row-icon">
              <Icon name={item.icon} />
            </span>
            <span className="nav-row-copy">
              <strong>{item.title}</strong>
              <small>{item.description}</small>
            </span>
            <Icon name="chevron_right" className="muted-icon" />
          </button>
        ))}
        <button type="button" className="nav-row danger-row" onClick={logout}>
          <span className="nav-row-icon">
            <Icon name="logout" />
          </span>
          <span className="nav-row-copy">
            <strong>Выйти</strong>
            <small>Сбросить локальную сессию</small>
          </span>
          <Icon name="chevron_right" className="muted-icon" />
        </button>
      </div>
    </section>
  );
};

export default More;
